import { createContext, useContext, useState, useCallback } from 'react'

const ToastContext = createContext(null)

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([])

  const showToast = useCallback((message, type = 'success') => {
    const id = Date.now()
    setToasts(t => [...t, { id, message, type }])
    setTimeout(() => {
      setToasts(t => t.filter(x => x.id !== id))
    }, 3000)
  }, [])

  const removeToast = (id) => setToasts(t => t.filter(x => x.id !== id))

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}

      {/* Toast container — fixed bottom center */}
      <div className="fixed bottom-6 left-1/2 z-50 flex flex-col gap-2"
        style={{ transform: 'translateX(-50%)', pointerEvents: 'none', minWidth: '260px' }}>
        {toasts.map(toast => (
          <div key={toast.id}
            onClick={() => removeToast(toast.id)}
            style={{
              pointerEvents: 'auto',
              background: toast.type === 'error' ? '#DC2626'
                : toast.type === 'warning' ? '#D97706'
                : toast.type === 'info' ? '#0B1F3A'
                : '#0B1F3A',
              borderLeft: '4px solid ' + (
                toast.type === 'error' ? '#FCA5A5'
                : toast.type === 'warning' ? '#FCD34D'
                : toast.type === 'info' ? '#4F9CF9'
                : '#2DD4BF'
              ),
              color: 'white',
              borderRadius: '12px',
              padding: '12px 16px',
              fontSize: '13px',
              fontWeight: 500,
              fontFamily: 'Space Grotesk',
              boxShadow: '0 8px 24px rgba(11,31,58,0.35)',
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              cursor: 'pointer',
              animation: 'slideUp 0.2s ease-out',
            }}>
            <span style={{ fontSize: '16px', flexShrink: 0 }}>
              {toast.type === 'error' ? '✕'
                : toast.type === 'warning' ? '⚠️'
                : toast.type === 'info' ? 'ℹ️'
                : '✓'}
            </span>
            <span style={{ flex: 1 }}>{toast.message}</span>
            <span style={{ opacity: 0.5, fontSize: '11px', flexShrink: 0 }}>tap to dismiss</span>
          </div>
        ))}
      </div>

      <style>{`
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(12px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </ToastContext.Provider>
  )
}

export function useToast() {
  const ctx = useContext(ToastContext)
  if (!ctx) throw new Error('useToast must be used inside ToastProvider')
  return ctx
}